<template>
  <div class="promoPage">
    <data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :options="addObj"
      @ok="addPromo"
    />
    <vs-table ref="table" :max-items="itemsPerPage" :data="promoCodes">
      <div slot="header" class="w-full">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewDataSidebar = true"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New Promo Code</span>
          </div>

          <!-- Search -->
          <!-- <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchPrompt = true"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Search</span>
          </div> -->

          <!-- <vs-prompt
            title="Search"
            @cancel="val = ''"
            @accept="searchQuery"
            @close="searchPrompt = false"
            :active.sync="searchPrompt"
          >
            <div class="con-exemple-prompt">
              <span>Enter a Phone# or Email to search</span>
              <vs-input
                @keyup.enter="searchQuery"
                placeholder="eg. john@company.com,Company Name...."
                vs-placeholder="eg. john@company.com,416499...."
                v-model="query"
                class="mt-3 w-full"
              />
            </div>
          </vs-prompt> -->
        </div>

        <!-- <div
          class="flex justify-between py-3 px-4 rounded"
          style="background:#eee"
          v-if="searchedTerm"
        >
          <span>
            Showing {{ searchResults.length }} results for
            <b>"{{ searchedTerm }}"</b>
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Search</vs-button
          >
        </div> -->

        <!-- ITEMS PER PAGE -->
      </div>

      <template slot="thead">
        <!-- <vs-th sort-key="name">Name</vs-th> -->
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="name">Code</vs-th>

        <vs-th sort-key="number">Discount</vs-th>
        <vs-th sort-key="">Details</vs-th>
        <vs-th sort-key="">Status</vs-th>
        <vs-th sort-key=""></vs-th>
        <vs-th sort-key=""></vs-th>
        <!-- <vs-th sort-key="order_status">Confirmed</vs-th> -->
        <!-- <vs-th sort-key="price">Price</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td>
              <router-link
                :to="`/account/${tr.id}`"
                class="product-name font-medium"
                >{{ tr.username }}</router-link
              >
            </vs-td> -->

            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.code }}</p>
            </vs-td>
            <vs-td id="valueTd" style="">
              {{ tr.type == "dollar" ? "$" : "" }}{{ tr.value
              }}{{ tr.type == "percentage" ? "%" : "" }}
            </vs-td>
            <vs-td>
              <p class="product-category" v-if="tr.expiry">
                {{ formatMonthDate(tr.expiry) }}
              </p>
            </vs-td>
            <vs-td>
              {{ tr.active ? "Active" : "Inactive" }}
            </vs-td>
            <vs-td>
              <vs-button
                @click.native="getPromoCode(tr)"
                radius
                color="green"
                type="filled"
                icon-pack="feather"
                size="small"
                icon="icon-edit"
              ></vs-button>
            </vs-td>
            <vs-td>
              <vs-button
                @click.native="deleteCode(tr)"
                radius
                color="danger"
                type="filled"
                icon-pack="feather"
                size="small"
                icon="icon-trash"
              ></vs-button>
            </vs-td>

            <!-- <vs-td>
                <vs-chip :color="getOrderStatusColor(tr.user.confirmed)" class="product-order-status">{{ tr.user.confirmed ? 'Yes' : 'No' }}</vs-chip>
              </vs-td> -->

            <!-- <vs-td>
                <p class="product-price">${{ tr.price }}</p>
              </vs-td> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-popup
      class="updatePopup"
      title="Update Promo Code"
      :active.sync="popupActivo"
    >
      <div class="activeStatus mt-6 flex items-center justify-start">
        <label for="activeToggleU" class="flex items-center cursor-pointer">
          <div class="relative">
            <input
              id="activeToggleU"
              type="checkbox"
              class="sr-only"
              v-model="promoFields.active"
            />
            <div
              class="w-10 h-6 bg-gray-400 rounded-full shadow-inner"
              style="background: #b5b5b5"
            ></div>
            <div
              class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"
            ></div>
          </div>
          <!-- label -->
          <div class="ml-3 text-gray-700 font-medium">
            {{ promoFields.active ? "Active" : "Inactive" }} Promo
          </div>
        </label>
      </div>
      <vs-input label="Name" v-model="promoFields.name" class="mt-5 w-full" />
      <vs-input
        label="Code (EG.RESOIL15OFF)"
        v-model="promoFields.code"
        class="mt-5 w-full"
        oninput="this.value = this.value.toUpperCase()"
      />
      <vs-input
        type="number"
        label="Minimum Purchase ($)"
        v-model="promoFields.minPurchase"
        class="mt-5 w-full"
      />
      <vs-input
        label="Expiry Date"
        type="date"
        v-model="promoFields.expiry"
        class="mt-5 w-full"
      />
      <vs-input
        label="Discount Value"
        v-model="promoFields.value"
        class="mt-5 w-full"
      />
      <vs-select
        class="mt-5 w-full"
        label="Percentage / Dollar"
        v-model="promoFields.type"
      >
        <vs-select-item value="percentage" text="Percentage (%)" />
        <vs-select-item value="dollar" text="Dollar ($)" />
      </vs-select>

      <div class="mt-8 w-full" v-if="promoFields">
        <vs-button class="mr-6" @click.native="updatePromo"> Update</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DataSidebar from "@/components/DataSidebar.vue";
import { $loading, formatMonthDate } from "@/assets/helper";
import moment from "moment";
export default {
  data() {
    return {
      promoCodes: [],
      itemsPerPage: 10,
      addNewDataSidebar: false,
      addObj: {
        api: "custom",
        apiType: "promotions",
        label: "Promo Code",
        promoTypeEnable: true,
        active: false,
        fields: [
          {
            label: "Name",
            type: "text",
            field: "name",
            required: true,
          },
          {
            label: "Code (EG.RESOIL15OFF)",
            type: "text",
            field: "code",
            oninput: "this.value = this.value.toUpperCase()",
            required: true,
          },

          {
            label: "Minimum Purchase ($$)",
            type: "number",
            field: "minPurchase",
          },
          {
            label: "Expiry Date",
            type: "date",
            field: "expiry",
          },
          {
            label: "Discount Value",
            type: "number",
            field: "value",
            required: true,
          },
        ],
      },
      popupActivo: false,

      promoFields: {
        id: "",
        name: "",
        code: "",
        value: 1,
        type: "",
        minPurchase: 0,
        active: null,
        expiry: "",
      },
      // promoFieldsActiveStatus: null,
    };
  },
  components: {
    DataSidebar,
  },
  async created() {
    // let query = { parentId: 234234 };

    await this.getPromoCodes();
  },
  computed: {
    // dataTransformed() {
    //   if (this.searchedTerm) return this.searchResults;
    //   return this.promoCodes;
    // },
  },
  // watch: {
  //   "promoFields.active": {
  //     handler: function (newVal, oldVal) {
  //       this.promoFieldsActiveStatus = newVal;
  //       console.log(this.promoFieldsActiveStatus);
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    formatMonthDate,
    async getPromoCodes() {
      // let accountId = this.$store.state.currentAccount.id;
      // console.log(accountId);
      let { data } = await this.$get(`/promo-codes`);
      this.promoCodes = data;
      console.log(this.promoCodes);
    },
    addPromo(obj) {
      $loading();
      console.log("ADDING PROMO", obj);
      obj.code = obj.code.trim().toUpperCase();
      if (obj.expiry) {
        obj.expiry = moment(obj.expiry).format("YYYY-MM-DD");
      }
      console.log(obj.active, "aaasssssss");

      this.$create("/promo-codes", obj)
        .then(({ data }) => {
          console.log(data);
          this.addNewDataSidebar = false;
          this.getPromoCodes();
          this.$vs.dialog({
            color: "success",
            title: `Promo Created`,
            text: `You have sucessfully created the promo code: ${data.code}`,
            // accept: () => this.$router.push(`/account/${data.id}`)
          });
        })
        .finally(() => {
          $loading.close();
        });
    },

    async getPromoCode(promo) {
      // $loading();
      console.log(promo);
      if (promo.expiry) {
        promo.expiry = moment(promo.expiry).utc().format("YYYY-MM-DD");
      }
      this.promoFields = promo;

      this.popupActivo = true;
    },
    updatePromo() {
      if (!this.promoFields) {
        this.$vs.dialog({
          color: "danger",
          title: `Caution`,
          text: `Please fill out all required fields to update the promo code`,
          // accept: () => this.$router.push(`/account/${data.id}`)
        });
      }
      $loading();
      this.$update(`/promo-codes/${this.promoFields.id}`, this.promoFields)
        .then(({ data }) => {
          console.log(data);
          this.popupActivo = false;
          this.getPromoCodes();
          this.$vs.dialog({
            color: "success",
            title: `Promo Updated`,
            text: `You have sucessfully updated the promo code: ${data.code}`,
            // accept: () => this.$router.push(`/account/${data.id}`)
          });
        })
        .finally(() => {
          $loading.close();
        });
    },
    deleteCode(promo) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Deletion`,
        text: `You are about to delete this code ${promo.code}. Please confirm that this is the action you want to perform.`,
        accept: () => this.acceptDelete(promo.id),
      });
    },
    async acceptDelete(promoId) {
      // console.log(promoId);
      this.$delete(`/promo-codes/${promoId}`)
        .then(({ data }) => {
          this.getPromoCodes();
          this.$vs.notify({
            color: "danger",
            title: "Deleted!",
            text: `The selected promo code was successfully deleted`,
          });

          // let idx = this.$data[where].findIndex(x => x.id === what.id)
        })
        .catch((err) => {
          console.error("ERROR", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.activeStatus {
  .dot {
    top: 0;
    right: 50%;
  }
  input:checked ~ .dot {
    transform: translateX(100%) !important;
    background-color: #598d7f !important;
  }
}
</style>
<style lang="scss">
#valueTd span {
  margin-left: 5px !important;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.promoPage {
}
</style>
